var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "gc-section-action-wrapper v-card v-sheet theme--light v-card--flat pa-3 my-2 rounded-lg apply-border",
      attrs: { id: `gc-section-wrapper-${_vm.sectionId}` },
      on: {
        mouseenter: function ($event) {
          _vm.showToolbar = true
        },
        mouseleave: function ($event) {
          _vm.showToolbar = false
        },
      },
    },
    [
      _c("content-section-toolbar", {
        attrs: {
          sectionId: _vm.contentSection.sectionId,
          visible: _vm.showToolbar,
          contentRestrictions: _vm.contentSection.contentRestrictions,
        },
        on: {
          copy: _vm.copyTextClicked,
          bookmark: _vm.bookmarkClicked,
          print: _vm.printClicked,
          share: _vm.shareClicked,
          fireMobileActions: _vm.mobileActionClicked,
        },
      }),
      _vm._v(" "),
      _c("content-section-title", {
        attrs: {
          title: _vm.contentSection.title,
          contentId: _vm.contentSection.sectionId,
          documentId: _vm.contentSection.documentId,
          isLink: _vm.isLink(_vm.contentSection),
        },
      }),
      _vm._v(" "),
      _c("content-section-content", {
        attrs: {
          content: _vm.contentSection.content,
          documentId: _vm.contentSection.documentId,
          sectionId: _vm.contentSection.sectionId,
          contentModifiers: _vm.contentModifiers,
        },
        on: { "text-highlighted": _vm.textHighlighted },
      }),
      _vm._v(" "),
      _c("content-section-insights"),
      _vm._v(" "),
      _c("content-section-user-bookmarks", {
        attrs: {
          bookmarks: _vm.contentSection.bookmarks,
          tags: _vm.tags,
          sectionId: _vm.contentSection.sectionId,
        },
      }),
      _vm._v(" "),
      _vm.contentSection?.breadcrumbs?.length !== 0
        ? _c("content-section-breadcrumb", {
            attrs: { breadcrumbs: _vm.contentSection?.breadcrumbs },
            on: { "breadcrumb-clicked": _vm.handleBreadcrumbClick },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }